import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';

/**
 * Component that sets the map reference for external control
 * This allows controlling the map from outside the MapContainer
 */
const SetMapRef = ({ mapRef }) => {
  // Always call hooks unconditionally at the top level
  const map = useMap();
  
  // Always call useEffect at the component top level
  useEffect(() => {
    // Only execute effect if in browser and we have valid references
    if (typeof window !== 'undefined' && mapRef) {
      mapRef.current = map;
    }
  }, [map, mapRef]);
  
  return null;
};

export default SetMapRef; 